define( function() {
	return ( /\S+/g );
} );



// WEBPACK FOOTER //
// ./~/jquery/src/var/rnotwhite.js